<template>
	<section v-if="items.length" class="main-content faq-section background-light">
		<div class="row row-header align-center">
			<h2 class="subtitle">FAQ</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row faq-row">
			<div class="columns column12">
				<div v-for="item in items" :key="item.ID" class="faq-item">
					<collapse :header="item.question" :content="item.answer" />
				</div>
			</div>
		</div>
		<div class="row align-center">
			<div class="columns column12">
				<nuxt-link class="button" :to="localePath('contact')">
					{{ $t('faqDifferentQuestion') }}
				</nuxt-link>
			</div>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.faq-item {
	text-align: left;
}

.faq-row {
	margin-bottom: 30px;
}
</style>
